import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { motion, AnimatePresence } from 'framer-motion';
import './WorkSection.css';

const workItems = [
  { id: 1, title: 'Google - Gemini Developer Competition', category: 'Innovation', tags: ['Experiences', 'Platform'], size: 'wide', img: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?q=80&w=1000&auto=format&fit=crop' },
  { id: 2, title: 'Bang & Olufsen - See yourself in Sound', category: 'Branding', tags: ['Experiences', 'Branding'], size: 'standard', img: 'https://images.unsplash.com/photo-1558403194-611308249627?q=80&w=1000&auto=format&fit=crop' },
  { id: 3, title: 'Gemini - AI for Every Developer', category: 'Digital', tags: ['Platform', 'Branding'], size: 'tall', img: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=1000&auto=format&fit=crop' },
  { id: 4, title: 'The best delivery experience not on earth.', category: 'Campaigns', tags: ['Experiences'], size: 'tall', img: 'https://images.unsplash.com/photo-1695653422715-9915256fe890?q=80&w=1000&auto=format&fit=crop' },
  { id: 5, title: 'Strava - Year In Sport', category: 'Community', tags: ['Platform', 'Products'], size: 'tall', img: 'https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=1000&auto=format&fit=crop' },
  { id: 6, title: 'Fingerspelling with Machine Learning', category: 'Innovation', tags: ['Experiences', 'Products'], size: 'wide', img: 'https://images.unsplash.com/photo-1531746790731-6c087fecd65a?q=80&w=1000&auto=format&fit=crop' },
  { id: 7, title: 'A delightful, welcoming identity for Netflix', category: 'Branding', tags: ['Branding', 'Identity'], size: 'standard', img: 'https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?q=80&w=1000&auto=format&fit=crop' },
  { id: 8, title: 'Google Gemini - Generative AI Apps', category: 'Digital', tags: ['Experiences'], size: 'tall', img: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?q=80&w=1000&auto=format&fit=crop' },
  { id: 9, title: 'The best things are the Simple Things', category: 'Campaigns', tags: ['Branding', 'E-commerce'], size: 'standard', img: 'https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?q=80&w=1000&auto=format&fit=crop' },
  { id: 10, title: 'Ramsjang Krea App', category: 'Digital', tags: ['Products'], size: 'tall', img: 'https://images.unsplash.com/photo-1555421689-d68471e189f2?q=80&w=1000&auto=format&fit=crop' },
  { id: 11, title: 'The Web Can Do What?! with Google', category: 'Innovation', tags: ['Experiences'], size: 'tall', img: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=1000&auto=format&fit=crop' },
  { id: 12, title: 'Undo the Firewall - Independent News', category: 'Community', tags: ['Experiences', 'Products'], size: 'wide', img: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?q=80&w=1000&auto=format&fit=crop' },
  { id: 13, title: 'Nike Air Max Identity', category: 'Branding', tags: ['Branding', 'Visuals'], size: 'tall', img: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?q=80&w=1000&auto=format&fit=crop' },
  { id: 14, title: 'Spotify Wrapped 2025', category: 'Digital', tags: ['Campaigns', 'Data'], size: 'standard', img: 'https://images.unsplash.com/photo-1614680376593-902f74cf0d41?q=80&w=1000&auto=format&fit=crop' },
  { id: 15, title: 'Apple Vision Pro Launch', category: 'Innovation', tags: ['Product', 'Launch'], size: 'wide', img: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?q=80&w=1000&auto=format&fit=crop' },
  { id: 16, title: 'Coca Cola Zero Campaign', category: 'Campaigns', tags: ['Branding'], size: 'tall', img: 'https://images.unsplash.com/photo-1622483767028-3f66f32aef97?q=80&w=1000&auto=format&fit=crop' },
  { id: 17, title: 'Herman Miller Rebrand', category: 'Branding', tags: ['Identity'], size: 'standard', img: 'https://images.unsplash.com/photo-1505843490538-5133c6c7d0e1?q=80&w=1000&auto=format&fit=crop' },
  { id: 18, title: 'Dyson Future Lab', category: 'Innovation', tags: ['R&D'], size: 'tall', img: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=1000&auto=format&fit=crop' },
  { id: 19, title: 'Starbucks Rewards', category: 'Digital', tags: ['App', 'Loyalty'], size: 'wide', img: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?q=80&w=1000&auto=format&fit=crop' },
  { id: 20, title: 'Lego Rebuild The World', category: 'Campaigns', tags: ['Global'], size: 'standard', img: 'https://images.unsplash.com/photo-1587654780291-39c940483713?q=80&w=1000&auto=format&fit=crop' },
];

const WorkSection = () => {
  const [filter, setFilter] = useState('All');

  const categories = ['All', 'Branding', 'Digital', 'Campaigns', 'Community', 'Innovation'];

  const filteredItems = filter === 'All'
    ? workItems
    : workItems.filter(item => item.category === filter);

  return (
    <section className="work-section" id="work">
      <Container>

        {/* HEADER */}
        <div className="work-header">
          <h2 className="work-title">
            Brand-led work <br /> from idea to execution.
          </h2>

          <div className="filter-wrapper">
            {categories.map(cat => (
              <button
                key={cat}
                className={`filter-pill ${filter === cat ? 'active' : ''}`}
                onClick={() => setFilter(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* GRID */}
        <motion.div layout className="work-grid">
          <AnimatePresence>
            {filteredItems.map(item => (
              <motion.div
                layout
                key={item.id}
                initial={{ opacity: 0, scale: 0.96 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.96 }}
                transition={{ duration: 0.35 }}
                className={`work-item ${item.size}`}
              >

                {/* FLOATING IMAGE */}
                <motion.div
                  className="work-card-inner"
                  whileHover={{
                    y: [-2, -10, -6],
                    rotate: [-0.3, 0.3, -0.3],
                    scale: 1.04
                  }}
                  transition={{
                    duration: 1.8,
                    ease: "easeInOut",
                    repeat: Infinity,
                    repeatType: "mirror"
                  }}
                >
                  <img
                    src={item.img}
                    alt={item.title}
                    className="work-img"
                    draggable="false"
                  />
                </motion.div>

                {/* META */}
                <div className="work-meta">
                  <h4>{item.title}</h4>
                  <div className="work-tags">
                    {item.tags.map((tag, idx) => (
                      <React.Fragment key={idx}>
                        <span className="tag-link">{tag}</span>
                        {idx < item.tags.length - 1 && <span className="dot">•</span>}
                      </React.Fragment>
                    ))}
                  </div>
                </div>

              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

      </Container>
    </section>
  );
};

export default WorkSection;
